import React from "react"
import * as L from 'leaflet';
import "leaflet.markercluster";
import "./osmap.scss"
import markerImageSrc from "../../images/map-marker.svg";
import NoImage from "../../images/pittis-no-image.png"
import { connectInfiniteHits } from 'react-instantsearch-core';

const OSMap = (props) => {

  const [hits, setHits] = React.useState([]);
  if (hits != props.hits) {
    //setRender(false)
    setHits(props.hits)
  }
  let _data = hits || "";

  const renderMap = (_data) => {

    if(_data?.length > 0) {
    var container = new L.DomUtil.get("map");

    if (container != null) {
    container._leaflet_id = null;
    }
    var map = new L.map('map').setView([51.1950576, 0.1822206], 13);
    new L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      zoom: 8,
      attribution: '© OpenStreetMap'
    }).addTo(map);

    if (typeof window !== 'undefined') {
      //const markersCluster = new L.MarkerClusterGroup();
      var markersCluster = new L.markerClusterGroup({
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: true,
          zoomToBoundsOnClick: true
      });
      var myIcon = new L.icon({
          iconUrl: markerImageSrc,
          shadowUrl: '',
      
          iconSize:     [22, 23], // size of the icon
          shadowSize:   [22, 23], // size of the shadow
          iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
          shadowAnchor: [4, 62],  // the same for the shadow
          popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
      });
    
      var bounds = new L.latLngBounds() // Instantiate LatLngBounds object
      for (let i in _data) {
          let _item = _data[i];
          let _markerId = _item.objectID;
          let _lat = _item._geoloc?.lat;
          let _lng = _item._geoloc?.lng;
          bounds.extend([_lat, _lng])// for fitbounds
          let _price = _item.price?.toLocaleString();
          let _html = _item.display_address;
          let _title = _item.title
          var image_url = ''
          if (_item?.images3) {
              image_url = _item?.images3?.images[0]?.['165x107'] || _item?.images3?.images_src[0];

          } else {
              image_url = NoImage
          }

          var url = ''
          if (_item.search_type === "sales") {
              url = '/property-for-sale/' + _item.slug + '-' + _item.crm_id
          }
          else if (_item.search_type === "lettings") {
              url = '/property-to-rent/' + _item.slug + '-' + _item.crm_id
          }

          markersCluster.addLayer(new L.marker([_lat, _lng], {icon: myIcon}).bindPopup('<div style="width: 350px;"><table style="width:100%;text-align:left"><tbody><tr style="padding: 2px;"><td style="width: 30%;padding: 4px;"><img src=' + image_url + ' style="width:165px;height:107px;object-fit: cover;padding: 2px;border-radius: 5px;box-shadow: 0 3px 14px rgba(0,0,0,0.4);"></td><td style="width: 70%;padding: 1px 5px;"><div style="padding: 0px 5px;"><b style="font-size: 1.28em;font-weight: 700;color: #3b83c0">£' + _price + '</b><div style="max-width: 160px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-weight: bold;">' + _html + '</div><div style="font-size:0.85rem;max-width: 150px;padding-top:2px;overflow: hidden;text-overflow: ellipsis;">' + _title + '<br><br><a style="font-weight:bold" target="_parent" href=' + process.env.GATSBY_SITE_URL + url + '>View Details</a></div></div></td></tr></tbody></table></div>').openPopup())

      } // for
      map.addLayer(markersCluster);
      map.fitBounds(bounds)
    }
  }
} // const renderMap = ()

  React.useEffect(() => {
        renderMap(hits)
  }, [hits])

  
  return (
    <div id="map"></div>
  )
}

const OSMapContainer = connectInfiniteHits(OSMap)

export default React.memo(OSMapContainer)